/**
 * Gatsby Browser Configuration
 *
 * Implement Gatsby's Browser APIs to customize your site's client-side behavior.
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Import global styles
import "./src/styles/global.css"

/**
 * Wrap the root element (optional)
 * Use this to add providers, context, or other wrapper components
 */
// export const wrapRootElement = ({ element }) => {
//   return element
// }

/**
 * Wrap each page element (optional)
 * Use this to add layout components or page-specific wrappers
 */
// export const wrapPageElement = ({ element, props }) => {
//   return element
// }

/**
 * Run when the client route changes
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  // Add any client-side route change logic here
  // For example, analytics tracking, scroll position reset, etc.
}

/**
 * Run when the Gatsby browser runtime first starts
 */
export const onClientEntry = () => {
  // Add any client-side initialization logic here
  // For example, service worker registration, analytics setup, etc.
}

/**
 * Handle service worker updates
 */
export const onServiceWorkerUpdateReady = () => {
  // Add logic for handling service worker updates
  // For example, show a notification to the user
}